import React from 'react';
import smoothScroll from '../../../utils/smoothScroll';

const Cta = ({
 url, translation, backgroundColor, textColor, ctaArrowColor, className, borderColor, id,
 noArrow, campaignType, anchorSmoothScroll,
}) => {
  const style = {
    color: textColor,
    backgroundColor,
    border: `2px solid ${borderColor}`,
  };

  const handleNavClick = (link) => {
    const sections = document.querySelectorAll('#campaign-system section');
    sections.forEach((section) => {
      const idName = section.id;
      if (link !== '' && idName === link) {
        smoothScroll(link, 100);
      }
    });
  };

  const aProps = {
    style,
    className: `cta shopnowButton ${className} ${campaignType === 'general' && noArrow ? 'noArrow' : ''}`,
  };
  if (id) aProps.id = id;
  if (url && anchorSmoothScroll !== true) aProps.href = url;
  if (anchorSmoothScroll) aProps.onClick = () => handleNavClick(url);
  return (
    <a
      {...aProps}
    >
      {translation}
      {(campaignType !== 'general' || noArrow !== true) &&
        <svg xmlns="http://www.w3.org/2000/svg" width="9.41" height="14" stroke={ctaArrowColor} fill="none" strokeWidth="2px" fillRule="evenodd" viewBox="0 0 9.41 14">
          <path
            className="cta-arrow"
            data-name="elements/arrow-cta.svg"
            d="M4106.25,694.01l5.99,5.989-5.99,5.99"
            transform="translate(-4103.84 -693)"
          />
        </svg>
      }
    </a>
  );
};

export default Cta;
